// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"90bc1a22","297":"6efee3bb","474":"4d74e049","643":"c139f34a"}[chunkId] + ".chunk.js";
};